import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column center>
          <CFView h3 futura bold color="#C39D86" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink href="https://www.facebook.com/pages/category/Sushi-Restaurant/Sushi-Modo-115886992366892/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Hitori Sushi Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/hitori_sushi/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Hitori Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C39D86" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink href="https://www.facebook.com/pages/category/Sushi-Restaurant/Sushi-Modo-115886992366892/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Hitori Sushi Facebook"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/hitori_sushi/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Hitori Sushi Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
